import Box from "@mui/material/Box";
import { EmtIcon } from "./EmtIcon";
import { styled, SxProps } from "@mui/material/styles";

export type EmtFloatingIconButtonProps = {
  /**
   * @default false
   */
  isActive?: boolean;
  /**
   * Icon Arrow direction
   * @default top
   */
  arrowDirection?: "up" | "down" | "left" | "right";
  /**
   * Handle filter click
   * @default undefined
   */
  onClick?: () => void;
  /**
   * @default undefined
   */
  sx?: SxProps;
  /**
   * Set if icon and color change automaticly
   * @default false
   */
  defaultEventHandler?: boolean;
  /**
   * set active boxshadow
   * @default false
   */
  boxShadow?: boolean;
  /**
   * icon class according to emtIcon
   * @default emt-dog
   */
  iconClass?: string;
  nonce?: string;
  className?: string;
};

const StyledBox = styled(Box)(({ theme }) => ({
  width: "38px",
  height: "38px",
  background: theme.palette.common.white,
  top: "16px",
  left: 0,
  zIndex: 2,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "16px",
  cursor: "pointer",
}));

const StyledEmtIcon = styled(EmtIcon)(({ theme }) => ({
  color: theme?.palette.primary.main,
  fontSize: "18px",
}));

export function EmtFloatingIconButton(props: EmtFloatingIconButtonProps) {
  const {
    onClick,
    className,
    sx,
    boxShadow = false,
    iconClass = "emt-dog",
  } = props;

  return (
    <StyledBox
      className={`emt-floating-button ${className || ""}`}
      onClick={() => {
        onClick ? onClick() : null;
      }}
      sx={{
        ...(boxShadow
          ? {
              boxShadow:
                "0px 8px 12px rgba(0, 0, 0, 0.08), 0px 4px 48px rgba(0, 0, 0, 0.08)",
            }
          : {}),
        cursor: onClick ? "pointer" : "default",
        ...sx,
      }}
    >
      <StyledEmtIcon className={iconClass} />
    </StyledBox>
  );
}
